enum Getter {
    TRANSACTIONS = "TRANSACTIONS",
    STATEMENT = "STATEMENT",
    LOGGED_IN = "LOGGED_IN",
    MAIL_ADDRESS = "MAIL_ADDRESS"
}
export default Getter;
